import React, { useEffect, useState } from "react";
import axios from "axios";
import Header from "../../components/header";
import { useNavigate } from "react-router-dom";
import ConfigCard from "../user-configuration/components/ConfigCard";
import api from "../../services/axios";
import { toast } from "react-hot-toast";
import { formatDate } from "./../../utils/common";

const Switch = ({ checked, onChange, disabled }) => (
  <label
    className={`inline-flex items-center cursor-pointer ${
      disabled ? "opacity-50 cursor-not-allowed" : ""
    }`}
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      className="sr-only peer"
    />
    <div
      className={`relative w-[40px] h-[16px] rounded-full transition-colors duration-300 ${
        checked
          ? "bg-[#2C81C3]"
          : "bg-white dark:bg-gray-700 border border-[#BDBFC7] dark:border-gray-600"
      }`}
    >
      <div
        className={`absolute top-[1px] left-[1px] h-[12px] w-[12px] rounded-full transition-transform duration-300 ${
          checked
            ? "translate-x-[25px] bg-white"
            : "bg-[#BDBFC7] dark:bg-gray-400"
        }`}
      />
    </div>
  </label>
);

const ChooseData = () => {
  const [orgData, setOrgData] = useState(null);
  const [organizationId, setOrganizationId] = useState(null);
  const [originalOrgData, setOriginalOrgData] = useState(null);
  const [isTransferAll, setIsTransferAll] = useState(true);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState(false);
  const [isSyncing, setIsSyncing] = useState(false);
  const [syncInfo, setSyncInfo] = useState(null);
  const [openAccordion, setOpenAccordion] = useState(null);
  const [unsavedChanges, setunsavedChanges] = useState({});
  const [error, setError] = useState({});
  const nav = useNavigate();

  const getOrigoData = async () => {
    try {
      const token = localStorage.getItem("origo_access_token");
      const orgId = localStorage.getItem("origo_org_id");

        if((!token || !orgId) && localStorage.getItem('origo_auth_url') && !localStorage.getItem('disconnected')){
          handleAuthorization();
          return
        }

      const orgRes = await axios.get(
        `${process.env.REACT_APP_ORIGO_BASE_URL}origo/get-org-data/${orgId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const realOrg = orgRes.data.data;
      setOrganizationId(realOrg.id);
      setOrgData(realOrg);
      setOriginalOrgData({
        tenantsMap: Object.fromEntries(
          realOrg.tenants.map((t) => [t.id, t.is_active])
        ),
        stationsMap: Object.fromEntries(
          realOrg.tenants.flatMap((t) =>
            t.stations.map((s) => [s.id, s.is_active])
          )
        ),
        sensorsMap: Object.fromEntries(
          realOrg.tenants.flatMap((t) =>
            t.stations.flatMap((s) => s.sensors.map((v) => [v.id, v.is_active]))
          )
        ),
      });
    } catch(err) {
      console.log(err)
      // alert("Failed to load organization data.", err);
      nav("/home");
    } finally {
      setLoading(false);
    }
  };

  const handleAuthorization = async () => {
    try {
      // if (login.organizationExists) {
        // ✅ Call /authorize for user
        const username = localStorage.getItem('origo_username');
        const password = localStorage.getItem('origo_password');
        const authRes = await axios.post(
          `${process.env.REACT_APP_ORIGO_BASE_URL}oauth-jd/authorize`,
          { username, password, isAdmin: false }
        );

        const auth = authRes?.data?.data || {};
        const access_token = auth.access_token;
        const organization_id = auth.organization_id;
        const jd_organization_id = auth.jd_organization_id;

        if (!access_token || !organization_id) {
          throw new Error('Authorization failed – missing token or organization ID');
        }

        localStorage.setItem('origo_access_token', access_token);
        localStorage.setItem('origo_org_id', organization_id.toString());
        localStorage.setItem('jd_organization_id', jd_organization_id ?? '');

        getOrigoData();
        return;
      // }
    } catch (err) {
      console.error('Authorization check failed:', err);
    }
  };

  useEffect(() => {
    getOrigoData();
  }, []);

  const handleAccordionToggle = (tenantId) => {
    setOpenAccordion(openAccordion === tenantId ? null : tenantId);
  };

  const toggleAll = (flag) => ({
    ...orgData,
    tenants: orgData.tenants.map((t) => ({
      ...t,
      is_active: flag,
      stations: t.stations.map((s) => ({
        ...s,
        is_active: flag,
        sensors: s.sensors.map((v) => ({ ...v, is_active: flag })),
      })),
    })),
  });

  const handleConvertLevel = (level, group) => {
    const token = localStorage.getItem("origo_access_token");
    const urlMap = {
      tenants: "toggle-tenants",
      stations: "toggle-stations",
      sensors: "toggle-sensors",
    };
    return axios.put(
      `${process.env.REACT_APP_ORIGO_BASE_URL}origo/${urlMap[level]}`,
      {
        organization_id: organizationId,
        ...(level === "tenants"
          ? { tenants: group.list }
          : level === "stations"
          ? { tenant_id: group.tenantId, stations: group.list }
          : {
              tenant_id: group.tenantId,
              station_id: group.stationId,
              sensors: group.list,
            }),
        toggle: group.toggle,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
  };

  const handleSave = async (
    checkedSensorIds,
    uncheckedSensorIds,
    aggregationData,
    title,
    payload
  ) => {
    try {
      const promises = [];

      checkedSensorIds.length &&
        promises.push(
          api.put("origo/toggle-sensors", {
            ...payload,
            sensors: checkedSensorIds,
            toggle: true,
          })
        );
      uncheckedSensorIds.length &&
        promises.push(
          api.put("origo/toggle-sensors", {
            ...payload,
            sensors: uncheckedSensorIds,
            toggle: false,
          })
        );

        if (aggregationData && aggregationData.length > 0) {
        promises.push(api.put('config/set-aggregation-types ', 
          aggregationData
        ));
      }

      await Promise.all(promises);
      toast.success(`${title} updated successfully!`);
      // onSave?.(checkedOptions);
    } catch (error) {
      console.error("Save failed:", error);
    }
  };

  const handleTransferAllToggle = () => {
    const newState = !isTransferAll;
    setIsTransferAll(newState);
    setOrgData(toggleAll(newState));
  };

  const handleDisconnect = async () => {
    try {
      localStorage.setItem("disconnected", "true");
      const orgId = localStorage.getItem("origo_org_id");
      const token = localStorage.getItem("origo_access_token");

      if (token && orgId) {
        await axios.delete(
          `${process.env.REACT_APP_ORIGO_BASE_URL}oauth-jd/disconnect`,
          {
            headers: { Authorization: `Bearer ${token}` },
            data: { organization_id: orgId },
          }
        );
      }

      /* leave creds but wipe tokens */
      const username = localStorage.getItem("origo_username");
      const password = localStorage.getItem("origo_password");

      localStorage.removeItem("origo_access_token");
      localStorage.removeItem("origo_org_id");
      localStorage.removeItem("jd_organization_id");
      localStorage.removeItem("origo_auth_url");

      /* immediately kick off JD OAuth again if we still have creds */
      if (username && password) {
        const { data } = await axios.post(
          `${process.env.REACT_APP_ORIGO_BASE_URL}oauth-jd/login`,
          { username, password, restart: false }
        );
        const url = data?.data?.authorizationUrl;
        if (url) {
          localStorage.setItem("origo_auth_url", url);
          nav("/home");
        }
      }

      nav("/home");
    } catch (e) {
      console.error("Disconnect failed", e);
      alert("Failed to disconnect.");
    }
  };

  const handleSync = async () => {
    if (syncInfo?.currently_in_sync || isSyncing) {
      alert("Sync is already in progress.");
      return;
    }

    try {
      setIsSyncing(true); // 🔒 Start syncing

      const orgId = localStorage.getItem("origo_org_id");
      const token = localStorage.getItem("origo_access_token");

      if (!token || !orgId) {
        alert(
          "Authorization token or organization ID is missing. Please log in again."
        );
        nav("/home");
        return;
      }

      await axios.get(`${process.env.REACT_APP_ORIGO_BASE_URL}origo/sync`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      alert("Sync started successfully!");
    } catch (e) {
      console.error("Sync failed", e);
      alert("Sync failed – try again.");
    } finally {
      try {
        const orgId = localStorage.getItem("origo_org_id");
        const token = localStorage.getItem("origo_access_token");

        const { data } = await axios.get(
          `${process.env.REACT_APP_ORIGO_BASE_URL}origo/last-sync`,
          {
            headers: { Authorization: `Bearer ${token}` },
            params: { organization_id: orgId },
          }
        );
        setSyncInfo(data); // ✅ Update sync info
      } catch (err) {
        console.error("Error refreshing sync info", err);
      }

      setIsSyncing(false); // ✅ Sync done → Re-enable button
    }
  };

  const handleEditLabel = async (id, label, original_title, sIdx, tIdx) => {
    try {
      await api.post(`config/set-user-defined-title`, 
        { 
          sensor_title:original_title,
          organization_id: Number(organizationId),
          user_defined_title: label} 
      );
      await getOrigoData();
      // setOrgData((prev) => {
      //   console.log(
      //     prev.tenants[tIdx].stations[sIdx].sensors.find(
      //       (s) => s.id === id
      //     ).origo_sensor_name
      //   );
      //   prev.tenants[tIdx].stations[sIdx].sensors.find(
      //     (s) => s.id === id
      //   ).origo_sensor_name = label;
      //   console.log(
      //     prev.tenants[tIdx].stations[sIdx].sensors.find(
      //       (s) => s.id === id
      //     ).origo_sensor_name
      //   );
      //   return { ...prev };
      // })
    } catch (error) {
      console.error("Update failed:", error);
      toast.error("Update failed. Please try again.");
    }
  }

  useEffect(() => {
    setError({...unsavedChanges})
  }, [unsavedChanges]);


  return (
    <div className="min-h-screen px-4 py-6 bg-gray-100 dark:bg-gray-900 text-black dark:text-white">
      <Header username="Omama" />
      <div className="h-px bg-gray-300 dark:bg-gray-700 mb-6" />
      {/* connection banner */}
      <div className="flex justify-between items-center px-4 py-3 border border-[#099d96] rounded bg-[#daf4f0] dark:bg-[#0d3d39] mb-4">
        <p className="text-lg font-semibold text-black dark:text-white">
          John Deere connection status:&nbsp;
          <span className="text-[#099d96] dark:text-[#34d1c5]">Connected</span>
        </p>
        <div className="flex items-center gap-3">
          
          <button
            onClick={handleDisconnect}
            className="bg-[#f06548] text-white px-4 py-2 rounded-full text-sm hover:opacity-90 transition"
          >
            Disconnect now
          </button>
        </div>
      </div>
      
      {/* sync info */}
      <div className="px-4 py-2 mb-4 text-sm text-gray-600 dark:text-gray-400 flex justify-between items-center">
        Last data sync: {syncInfo?.last_successful_sync ? formatDate(syncInfo.last_successful_sync) : "—"}
        <button
            onClick={handleSync}
            disabled={isSyncing || syncInfo?.currently_in_sync}
            className={`px-4 py-2 rounded-full text-sm font-semibold transition ${
              isSyncing || syncInfo?.currently_in_sync
                ? "bg-gray-400 text-gray-600 cursor-not-allowed"
                : "bg-[#2C81C3] text-white hover:bg-[#1e5a8a]"
            }`}
          >
            {isSyncing || syncInfo?.currently_in_sync
              ? "Syncing..."
              : "Sync now"}
          </button>
      </div>

      <div className="bg-white dark:bg-gray-800 pb-6">
        <div className="flex justify-between items-center mb-6 p-6">
          <h2 className="text-lg font-semibold">
            Choose data you want to select
          </h2>
          <div className="flex items-center gap-2.5">
            <span className="text-sm">Select all</span>
            <Switch
              checked={isTransferAll}
              onChange={handleTransferAllToggle}
            />
          </div>
        </div>

        {loading ? (
          <div className="text-center py-10">Loading...</div>
        ) : (
          <div className="px-4">
            {orgData?.tenants?.map((tenant, tIdx) => (
              <div
                key={tenant.id}
                className="collapse collapse-arrow border border-gray-200 dark:border-gray-700 rounded-lg mb-4"
              >
                <input
                  type="checkbox"
                  checked={openAccordion === tenant.id}
                  onChange={() => handleAccordionToggle(tenant.id)}
                />
                <div className="collapse-title text-lg font-medium bg-gray-50 dark:bg-gray-700 text-gray-900 dark:text-white">
                  {tenant.origo_tenant_name}
                  <span className="text-sm font-normal text-gray-600 dark:text-gray-400 ml-2">
                    ({tenant.stations.filter(station => station.sensors && station.sensors.length > 0).length} stations)
                  </span>
                </div>
                <div className="collapse-content bg-gray-50 dark:bg-gray-700">
                  <div className="flex flex-wrap gap-6 pt-4">
                    {tenant.stations
                      .filter(station => station.sensors && station.sensors.length > 0)
                      .map((station, sIdx) => (
                      <ConfigCard
                        key={station.id}
                        title={station.origo_station_name}
                        total={station.sensors.length}
                        selected={
                          station.sensors.filter((s) => s.is_active).length
                        }
                        options={station.sensors.map((s) => {
                          const availableTypes = s?.aggregation_types || [];
                          const userSelectedTypes = s?.user_selected_aggregation_types;
                          
                          let aggregationTypesMap = [];
                          
                          if (userSelectedTypes === null || userSelectedTypes === undefined) {
                            // If user_selected_aggregation_types is null, all aggregation_types should be true
                            aggregationTypesMap = availableTypes.map(type => ({[type]: true}));
                          } else {
                            // Normal case: available types default to false, user selected types are true
                            aggregationTypesMap = [
                              ...availableTypes.map(type => ({[type]: false})),
                              ...(userSelectedTypes || []).map(type => ({[type]: true})),
                            ];
                          }
                          
                          return {
                            id: s.id,
                            label: s.origo_sensor_user_defined_title || s.origo_sensor_name,
                            checked: s.is_active,
                            original_title: s.origo_sensor_name,
                            aggregation_types: aggregationTypesMap,
                            available_aggregation_types: availableTypes,
                            has_single_aggregation: availableTypes.length === 1,
                          };
                        })}
                        stationData={{
                          organization_id: organizationId,
                          tenant_id: tenant.id,
                          station_id: station.id,
                        }}
                        onSave={(checkedOptions, uncheckedOptions, aggregationData) => {
                          handleSave(
                            checkedOptions,
                            uncheckedOptions,
                            aggregationData,
                            station.origo_station_name,
                            {
                              organization_id: Number(organizationId),
                              tenant_id: tenant.id,
                              station_id: station.id,
                            }
                          );
                        }}
                        onEditLabel={(id, label, original_title) => {
                          handleEditLabel(id, label, original_title, sIdx, tIdx)
                        }
                        }
                        setunsavedChanges={setunsavedChanges}
                        showError={Object.keys(error).includes(station.id.toString()) && error[station.id]}
                        // isEditable={false}
                      />
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ChooseData;
